import { render, staticRenderFns } from "./ComponentRenderStats.vue?vue&type=template&id=73beb4c4&scoped=true&"
import script from "./ComponentRenderStats.vue?vue&type=script&lang=js&"
export * from "./ComponentRenderStats.vue?vue&type=script&lang=js&"
import style0 from "./ComponentRenderStats.vue?vue&type=style&index=0&id=73beb4c4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73beb4c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/akryum/Projects/vue-devtools/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73beb4c4')) {
      api.createRecord('73beb4c4', component.options)
    } else {
      api.reload('73beb4c4', component.options)
    }
    module.hot.accept("./ComponentRenderStats.vue?vue&type=template&id=73beb4c4&scoped=true&", function () {
      api.rerender('73beb4c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@vue-devtools/app-frontend/src/views/perf/ComponentRenderStats.vue"
export default component.exports